/**
 * Split `items` into consecutive chunks of at most `size`.
 *
 * Used to batch `where(documentId(), "in", ids)` reads — Firestore caps an
 * `in` filter at 30 values (FIRESTORE_IN_LIMIT).
 */
export const FIRESTORE_IN_LIMIT = 30;

export function chunk<T>(items: readonly T[], size: number): T[][] {
  if (!Number.isInteger(size) || size < 1) throw new RangeError(`chunk size must be a positive integer, got ${size}`);
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += size) out.push(items.slice(i, i + size));
  return out;
}
